<template>
  <div class="my-3 my-md-5">
    <div class="container-fluid" style="padding: 16px">
      <div class="row">
        <div style="display: flex; width: 100%">
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            :collapse="isCollapse"
          >
            <el-menu-item
              index="0"
              style="text-align: center"
              @click="isCollapse = !isCollapse"
            >
              <FAIcon icon="el-icon-menu" title="Ẩn/hiện Menu" />
            </el-menu-item>

            <div style="text-align: left; width: 80%; margin: 0 auto">
              <b-link :to="{ name: 'setting_management' }" class="menu-item">
                <el-menu-item index="2">
                  <FAIcon icon="far fa-file-alt icon-dashboard" />
                  <span slot="title"> Quản lý cấu hình</span>
                </el-menu-item>
              </b-link>

              <b-link :to="{ name: 'mail_history' }" class="menu-item">
                <el-menu-item index="3">
                  <FAIcon icon="fas fa-users icon-dashboard" />
                  <span slot="title"> Quản lý email</span>
                </el-menu-item>
              </b-link>
            </div>
          </el-menu>
          <router-view class="dashboard-container"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FAIcon from "@/components/common/FAIcon.vue"

export default {
  name: "RootDashboard",
  components: { FAIcon },
  data: function () {
    return {
      isCollapse: false,
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
  },
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 310px;
  min-height: 400px;
  text-align: center;
}
</style>
<style scoped>
.icon-dashboard {
  width: 24px;
  height: 24px;
  text-align: center;
  align-items: center;
  padding: 4px;
}

.menu-item {
  cursor: pointer;
  color: #4a4a4a;
  text-decoration: none !important;
  /*padding-left: 20px;*/
}

.my-3.my-md-5 {
  height: 100%;
  position: relative;
  text-align: left;
  background-color: #f5f7fb;
  margin: 0 !important;
}

.col-md-3,
.col-md-9 {
  margin: 30px 0;
}

.list-group-transparent .list-group-item {
  background: none;
  border: 0;
  font-weight: 400;
  padding: 0.5rem 1rem;
  border-radius: 3px;
  font-size: 15px;
}

.list-group-transparent .list-group-item.active {
  background: rgba(70, 127, 207, 0.06);
  font-weight: 600;
  color: #467fcf;
}

.list-group-transparent .list-group-item:hover {
  background: rgba(70, 127, 207, 0.06);
  font-weight: 600;
  color: #467fcf;
}

.mr-3,
.mx-3 {
  margin-right: 0.75rem !important;
}

.card-img-top {
  color: white;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.dashboard-container {
  margin: 0 8px;
  width: 100%;
  background-color: #fff;
  padding: 20px;
}
</style>
